import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import FullButton from './FullButton';

interface ErrorDetail {
  target: string;
  message: string;
}

interface PublishErrorProps {
  error: {
    message: string;
    details?: ErrorDetail[];
  };
  onEditListing: () => void;
  showEditButton?: boolean;
}

const PublishError: React.FC<PublishErrorProps> = ({
  error,
  onEditListing,
  showEditButton = true,
}) => {
  return (
    <Box sx={{ mx: 1.5 }}>
      <Alert severity="error" sx={{ mb: 2, mt: 3 }}>
        <Typography>{error.message}</Typography>
      </Alert>

      {error?.details && Array.isArray(error.details) && (
        <Box sx={{ mt: 2, mb: showEditButton ? 10 : 2 }}>
          {error.details.map((detail: ErrorDetail, index: number) => (
            <Box
              key={index}
              sx={{
                mb: 1.5,
                pl: 2,
                borderLeft: '4px solid',
                borderLeftColor: 'error.light',
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: 'grey.700',
                  mb: 0.5,
                }}
              >
                {detail.target}
              </Typography>
              <Typography variant="body2" sx={{ color: 'grey.600' }}>
                {detail.message}
              </Typography>
            </Box>
          ))}
        </Box>
      )}

      {showEditButton && (
        <FullButton text={'Edit Listing'} onClick={onEditListing} />
      )}
    </Box>
  );
};

export default PublishError;
